import { c as _c } from "react/compiler-runtime";
import AlertErrorIcon from '@precis-digital/kurama/icons/AlertErrorIcon';
import AlertInfoIcon from '@precis-digital/kurama/icons/AlertInfoIcon';
import AlertWarningIcon from '@precis-digital/kurama/icons/AlertWarningIcon';
import ResizeLeftRightIcon from '@precis-digital/kurama/icons/ResizeLeftRightIcon';
import { type ReactElement } from 'react';
const IconTemplates = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div id="chart-card-icon-templates" style={t0} aria-hidden="true"><AlertInfoIcon data-alert-type="info" /><AlertWarningIcon data-alert-type="warning" /><AlertErrorIcon data-alert-type="error" /><ResizeLeftRightIcon data-resize-type="left-right" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default IconTemplates;